const serverName = "https://hotedrsica.si";

export const environment = {
    registerURL: `${serverName}/api/register`,
    loginURL: `${serverName}/api/login`,
    registerFarmURL: `${serverName}/api/register-farm`,
    getAllFarmsURL: `${serverName}/api/all-farms`,
    getAllUsersURL: `${serverName}/api/all-users`,
    getUserInfoURL: `${serverName}/api/profile`,
    updateUserInfoURL: `${serverName}/api/user/info/update`,
    testTokenRequiredURL: `${serverName}/api/protected-resource`,
    getFarmInfoURL: `${serverName}/api/farm-info`,
    updateFarmInfoURL: `${serverName}/api/farm-info`,
    farmURL: `${serverName}/api/farm`,
    addEmployeeURL: `${serverName}/api/employee`,
    productURL: `${serverName}/api/product`,
    updateProductURL: `${serverName}/api/update-product`,
    updateEmployeeURL: `${serverName}/api/update-employee`,
    sendMessageToProductOwnerURL: `${serverName}/api/message-product-owner`,
    eventURL: `${serverName}/api/events`,
    testServerURL: `${serverName}/api/test-server`,
    farmLocationsURL: `${serverName}/api/farm-locations`,
    statistics: `${serverName}/api/statistics`,
    user: `${serverName}/api/user`,
    sendAdminMessage: `${serverName}/api/message-product-owner-admin`,
    sendMessageToFarmURL: `${serverName}/api/message-farm`,
    getUserEmailURL: `${serverName}/api/user-email`,
    getFarmInfoUserURL: `${serverName}/api/farm-info-user`,
    getFarmImagesURL: `${serverName}/api/farm-images`,
    updateProductWithImageURL: `${serverName}/api/update-product-with-image`,
    deleteMessageURL: `${serverName}/api/delete-message`,
    deleteSubscriberURL: `${serverName}/api/delete-subscriber`,
    deleteUserURL: `${serverName}/api/delete-user`,
    getOrganisationByIdURL: `${serverName}/api/organisationById`,
    organisationURL: `${serverName}/api/organisations`,
    newsURL: `${serverName}/api/news`,
    hot100loginURL: `${serverName}/api/hot100-login`,
    hot100csvURL: `${serverName}/api/hot100-csv`,
    leadersURL: `${serverName}/api/leaders`,
    orgImagesURL: `${serverName}/api/org-images`,
    hallReservationsURL: `${serverName}/api/hall-reservations`,
    reportsURL: `${serverName}/api/reports`,
    friendshipRaceURL: `${serverName}/api/friendshipRace`,
    friendshipRaceCsvURL: `${serverName}/api/friendshipRace-csv`,
    eventExposeURL: `${serverName}/api/events/toggle_expose`,
    exercisesURL: `${serverName}/api/exercises`,
    varstvoURL: `${serverName}/api/varstvo`,
    varstvoCsvURL: `${serverName}/api/varstvo-csv`,
    skiTrailsURL: `${serverName}/api/ski-trails`,
    vanRentalURL: `${serverName}/api/van-reservations`,
    getOrganisationByNameURL: `${serverName}/api/organisation-by-name`,
    administratorsURL: `${serverName}/api/admin`,
    cold50csvURL: `${serverName}/api/cold50-csv`,
    cold50URL: `${serverName}/api/cold50`,
}

export const siteKey = "6LcSXd4qAAAAAMgTmY4ybwhFhceBS9fNBCiY4t8d";

export const imageLocation = serverName;
export const reportLocation = serverName;
